module.exports = {
  NAME: "Default",
  PROJECT_NAME: "Diced Digital",
  //Urls should not have trailing slash
  HTML_ROOT_ID: "modal-root",
  SERVER_URL: "http://localhost:4000",
  CLIENT_URL: "http://localhost:3000",
  LANDING_URL: "http://localhost:3000",
  GOOGLE_CLIENT_ID:
    "1092564513780-rdhenfi8go2oeoesarnirb0l9aaimkri.apps.googleusercontent.com",
  GOOGLE_CLIENT_SECRET: "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",
  LOGROCKET_KEY: "",
  POSTHOG_KEY: "",
};
